// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__ykQJN","menuItem":"styles_menuItem__c8E88","activeItem":"styles_activeItem__pPNKe"};